import { ActionReducerMap, createFeatureSelector } from "@ngrx/store";

import * as fromAssets from "./assets.reducer";

// this is the type for our assignables.module
// this creates the structure for our state tree
export interface CreateState {
    assets: fromAssets.AssetsState;
}

// register the reducers
// a slice of state is managed by a reducer function
// ** Remember a reducer is a pure function
// this can be type check with ActionReducerMap as type CreateState
export const reducers: ActionReducerMap<CreateState> = {
    assets: fromAssets.reducer,
};

// This const creates the base level of our state object
// A reference to our Assignables State
// and will hold a selector for the entire lazy-loaded module
export const getCreateModuleState = createFeatureSelector<CreateState>(
    "createModule"
);
